import React from 'react';
import { Col, Row } from '@app/ui';
import BroadcastViewership from './viewership/BroadcastViewership';
import { useBroadcastsContext } from '../BroadcastsContext';
import BroadcastExposures from './exposures/BroadcastExposures';
import BroadcastVerbalMentions from './verbal-mentions/BroadcastVerbalMentions';
import BroadcastDemographics from './demographics/BroadcastDemographics';
import { BroadcastTab } from '../utils/broadcastsUtils';

const BroadcastsTabContent = () => {
    const {
        client,
        activeTab,
        viewershipType,
        viewershipFilteredBroadcastName,
        broadcastsQuery,
        hasBroadcastImpressionsPermission,
        hasBroadcastDemographicsPermission,
        setViewershipFilteredBroadcastName,
    } = useBroadcastsContext();

    return (
        <div>
            {activeTab === BroadcastTab.VIEWERSHIP &&
                hasBroadcastImpressionsPermission && (
                    <Row gutter={16}>
                        <Col span={24}>
                            <BroadcastViewership
                                searchParams={broadcastsQuery}
                                client={client}
                                selectedBroadcastName={
                                    viewershipFilteredBroadcastName
                                }
                                setSelectedBroadcastName={
                                    setViewershipFilteredBroadcastName
                                }
                                viewershipType={viewershipType}
                            />
                        </Col>
                    </Row>
                )}
            {activeTab === BroadcastTab.EXPOSURES && <BroadcastExposures />}
            {activeTab === BroadcastTab.VERBAL_MENTIONS && (
                <BroadcastVerbalMentions />
            )}
            {activeTab === BroadcastTab.DEMOGRAPHICS &&
                hasBroadcastDemographicsPermission && <BroadcastDemographics />}
        </div>
    );
};

export default BroadcastsTabContent;
